import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import FreeBackgroundChecks from './FreeBackgroundChecks';
import messages from '../../../locale/messages';

function action({ store, intl }) {
    const title = intl.formatMessage(messages.freeBackgroundChecks);

    const isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
    if (!isAdminAuthenticated) {
        return { redirect: '/login' };
    }

    return {
        title,
        component: (
            <AdminLayout>
                <FreeBackgroundChecks />
            </AdminLayout>
        ),
    };
}

export default action;
